module.exports = __webpack_public_path__ + "1aa236171b3067d04582fe5b0dbc9846.svg";